<template>
  <div>
      <div class="pagination-w">
        <div class="pagination-info" v-if="pagination.nbHits">SHOWING {{pagination.offset + 1}}-{{Math.min(pagination.offset + pagination.limit, pagination.nbHits)}} OF {{pagination.nbHits}} RECORDS</div>
        <div class="pagination-info" v-else></div>
          <div class="pagination-links">
              <ul class="pagination">
                  <li class="page-item" :class="(pagination.current_page <= 1 || pagination.offset == 0 ? 'disabled' : '')"><a class="page-link" @click.prevent="changePage('previous')"> Previous</a></li>

                  <li class="page-item" :class="(pagination.data.length == 0 ? 'disabled' : '')" v-if="pagination.data">
                    <a class="page-link" @click.prevent="changePage('next')"> Next</a>
                  </li>
                  <li class="page-item" :class="(pagination.offset > pagination.nbHits ? 'disabled' : '')" v-if="pagination.nbHits">
                    <a class="page-link" @click.prevent="changePage('next')"> Next</a>
                  </li>
              </ul>
          </div>
      </div>
  </div>
</template>

<script>
export default {
  props: ['pagination'],
  methods: {
    changePage (direction) {
      if(this.pagination.current_page) {
        var page = direction == 'next' ? this.pagination.current_page + 1 : this.pagination.current_page - 1
        this.pagination.current_page = page
      } else {
        var offset = direction == 'next' ? this.pagination.offset + this.pagination.limit : this.pagination.offset - this.pagination.limit
        this.pagination.offset = offset
      }
      this.$emit('paginate')
    }
  }
}
</script>

<style>
.pagination-w {
  background: #ddd !important;
}
</style>